<template>
  <div class="news">
    <banner :img="bannerImg" title="新闻资讯" titleEng="News" />
    <div class="news-section" v-loading="loading" >
      <div class="news-wrap" :style="{backgroundImage: `url(${bgContent})`}">
        <div class="news-section-content">
          <div class="content-nav">
            <div
              class="content-nav-btn"
              :class="{'content-nav-active':newstype == 1}"
              @click="newstype = 1"
            >
              <span>公司新闻</span>
            </div>
            <div
              class="content-nav-btn"
              :class="{'content-nav-active':newstype == 2}"
              @click="newstype = 2 "
            >
              <span>行业动态</span>
            </div>
          </div>
  
          <div class="content-nav-item">
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide v-for="(item) in newsList" :key="item.id">
                  <div class="item-list" @click="$router.push(`/newsdetails/${item.id}`)">
                    <div class="item-img" v-lazy:background-image="item.coverImg"></div>
        
                    <p class="item-list-title">
                      <span>{{ item.title }}</span>
                    </p>
                    <p class="item-list-content">{{item.descContent}}</p>
                    <div class="item-list-more">
                      <router-link
                        class="text-decoration"
                        to=""
                      >
                        <img src="../assets/img/sanjiao.png" />
                        <span>more</span>
                      </router-link>
                    </div>
                  </div>
                </swiper-slide>
                <!-- <div class="swiper-pagination" slot="pagination"></div> -->
              </swiper>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            <!-- <swiper :newsList="newsList"></swiper> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleByCateId,getWebsiteConfigList } from '../api';
import Banner from "../components/Banner";
// import Swiper from '../components/swiper.vue';
// import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "news",
  components: {
    Banner,
    // swiper,
    // swiperSlide
  },
  data() {
    return {
      loading: true,
      newsList: [],
      newstype: 1,
      swiperOption: {
        slidesPerView:3,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        // pagination: {
        //     el: '.swiper-pagination',
        //     clickable: true
        //   }
      },
      bgContent: '',
      bannerImg: ''
    };
  },
  methods: {
    loadData() {
    //   this.loading = true;
    //   this.$http
    //     .get(`News?type=${this.newstype}&num=6`)
    //     .then(response => {
    //       //console.log(response);
    //       this.newsList = response.data;
    //       this.loading = false;
    //       //window.console.log(this.newsList);
    //     })
    //     .catch(function(error) {
    //       window.console.log(error);
    //     });
      getArticleByCateId({
        cateId: this.newstype === 1 ? '9' : '8',
      }).then(res => {
        this.newsList = res.data
        this.loading = false
      })
    }
  },
  created() {
    if (window.innerWidth < 970) {
      this.swiperOption.slidesPerView = 1
    }
    getWebsiteConfigList().then(res => {
      this.bgContent = res.data.find(item => item.code === 'bg_news').title
      this.bannerImg = res.data.some(item => item.code === 'bg_banner_news') ? res.data.find(item => item.code === 'bg_banner_news').title : ''

    })
  },
  mounted() {
    this.loadData();
  },
  watch: {
    newstype(type) {
      window.console.log(type);
      this.loadData();
    },
    newsList() {
      this.$nextTick(() => {
        if (this.$refs.mySwiper) {
          this.$refs.mySwiper.swiper.slideTo(0);
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.news {
  width: 100%;
  height: 100%;
  background-color: #14679f;
  position: relative;
  overflow: hidden;
  ::v-deep {
          .swiper-container {
            width: 100%;
          }
            // .swiper-wrapper {
            //   display: flex;
            //   overflow-x: auto;
            // }
          .swiper-button-prev {
            left: -26px;
          }
          .swiper-button-next {
            right: -16px;
          }
        }

  &-section {
    width: 100%;
    //height: 1600px;
    background-size: 100%;
    background-repeat: no-repeat;
    // padding-bottom: 60px;
    background-color: #14679f;
    .news-wrap {
      width: 1340px;
      margin: 0 auto;
      background-color: #fff;
      padding: 55px 0;
    }

    &-content {
      width: 1180px;
      //height: 1600px;
      margin: 0 auto;
      // background-color: #fff;
      // border: 1px solid red;
      box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.15);
      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        // border: 1px solid red;

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
          cursor: pointer;
        }

        .content-nav-active {
          background-color: #14679f;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        //border: 1px solid blue;
        position: relative;
        padding-bottom: 50px;
        ::v-deep {
          .swiper-container {
            width: 100%;
            overflow: hidden;
            .swiper-wrapper {
              // overflow: hidden;
              // display: flex;
              // overflow-x: auto;
            }
          }
          // ::v-deep {
            // .swiper-wrapper {
            //   display: flex;
            //   overflow-x: auto;
            // }
            .swiper-button-prev {
              left: -26px;
            }
            .swiper-button-next {
              right: -16px;
            }
          // }
        }

        .item-list {
          width: 330px;
          height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px 10px 40px 10px;
          // border: 1px solid #15669e;
          cursor: pointer;
          box-shadow: 0 0 3px 1px #eee;
          box-sizing: border-box;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 300px;
            height: 210px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
            background-origin: content-box;
            transition: all .4s;
            &:hover {
              background-size: 120%;
            }
          }

          &-title {
            max-width: 300px;
            // height: 60px;
            color: #000;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            position: relative;
            span {
              background: linear-gradient(to right, #000000,#000000) no-repeat left bottom;
              background-size: 0 2px;
              transition: all 0.4s;
              &:hover {
                background-size: 100% 2px;
              }
            }
            // &::after {
            //   transition: all 0.5s;
            //   content: '';
            //   position: absolute;
            //   bottom: 18px;
            //   left: 0;
            //   width: 0;
            //   height: 1px;
            //   background: #000;
            // }
            // &:hover::after {
            //   width: 100%;
            // }
            
            // border-left: 1px solid #15669e;
          }

          &-content {
            width: 300px;
            height: 100px;
            font-size: 16px;
            color: #333;

            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            text-align: justify;
            line-height: 20px;
            // letter-spacing: 1px;
            // 文本长度处理 ending
          }

          &-more {
            width: 300px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #14679f;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}

@media screen and (max-width: 997px) {
  .news {
    &-wrap {
      width: 100vw;
    }
    &-section {
      .news-wrap {
        width: 100vw;
      }
      &-content {
        width: calc(100% - 20px);
        .content-nav {
          width: calc(100% - 10px);
        }
        .content-nav-item {
          width: calc(100% - 40px);
        }
      }
    }
  }
}
</style>